// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1H2tW","title":"Header_title__1scYo","side":"Header_side__1A5YA"};